export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const REPORTS = "REPORTS";
export const CONTACT_MESSAGE_LIST = "CONTACT_MESSAGE_LIST";
export const ORDER_RECENT = "ORDER_RECENT";
export const ORDER_RECENT_DELETE = "ORDER_RECENT_DELETE";
export const ORDER_LIST = "ORDER_LIST";
export const ORDER_PLACED_LIST = "ORDER_LIST";
export const ORDER_DELETE = "ORDER_DELETE";
export const ORDER_DETAIL = "ORDER_DETAIL";
export const ORDER_UPDATE = "ORDER_UPDATE";
export const FLEET_LIST = "FLEET_LIST";
export const FLEET_ADD = "FLEET_ADD";
export const ORDER_UPDATE_FLEET = "ORDER_UPDATE_FLEET";
export const FLEET_UPDATE = "FLEET_UPDATE";
export const FLEET_DETAIL = "FLEET_DETAIL";
export const FLEET_DELETE = "FLEET_DELETE";
export const Staff_LIST = "Staff_LIST";
export const Staff_DETAIL = "Staff_DETAIL";
export const Staff_UPDATE = "Staff_UPDATE";
export const Staff_ADD = "Staff_ADD";
export const STAFF_DELETE = "STAFF_DELETE";
export const SERVICES_LIST = "SERVICES_LIST";
export const SERVICES_ADD = "SERVICES_ADD";
export const SERVICES_DELETE = "SERVICES_DELETE";
export const SERVICES_UPDATE = "SERVICES_UPDATE";
export const SERVICES_DETAIL = "SERVICES_DETAIL";
export const CUSTOMERS_LIST = "CUSTOMERS_LIST";
export const CUSTOMERS_UPDATE = "CUSTOMERS_UPDATE";
export const CUSTOMERS_ADD = "CUSTOMERS_ADD";
export const CUSTOMERS_DETAIL = "CUSTOMERS_DETAIL";
export const CUSTOMERS_DELETE = "CUSTOMERS_DELETE";
export const MEMBERSHIPS_LIST = "MEMBERSHIPS_LIST";
export const MEMBERSHIPS_ADD = "MEMBERSHIPS_ADD";
export const MEMBERSHIPS_DETAIL = "MEMBERSHIPS_DETAIL";
export const MEMBERSHIPS_DELETE = "MEMBERSHIPS_DELETE";
export const MEMBERSHIPS_UPDATE = "MEMBERSHIPS_UPDATE";
export const PROFILE_UPDATE = "PROFILE_UPDATE";
export const NOTIFICATION_LIST = "NOTIFICATION_LIST";
export const SEND_OTP = "SEND_OTP";
export const UNVIEWED_NOTIFICATION_LIST = "UNVIEWED_NOTIFICATION_LIST";
export const NOTIFICATION_DELETE = "NOTIFICATION_DELETE";
export const STRIPE_LIST = "STRIPE_LIST";
export const BELL_DATA = "BELL_DATA";
export const PARENT_CATEGORY_LIST = "PARENT_CATEGORY_LIST";
export const ADD_CHECKLISTS = "ADD_CHECKLISTS";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const CHECK_LIST_ITEMS = "CHECK_LIST_ITEMS";
export const UPDATE_CHECKLISTS = "UPDATE_CHECKLISTS";
export const CHECKLIST_DELETE = "CHECKLIST_DELETE";
export const CHECKLIST_CAT_UPDATE = "CHECKLIST_CAT_UPDATE";
export const CHECK_LIST = "CHECK_LIST";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const GET_CAT_BY_ID = "GET_CAT_BY_ID";
export const ORDER_UPDATE_VEHICLE = "ORDER_UPDATE_VEHICLE";
export const VEHICLES_LIST = "VEHICLES_LIST";
export const ADD_VEHICLE = "ADD_VEHICLE";
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";
export const VEHICLE_DELETE = "VEHICLE_DELETE";
export const RENT_VEHICLE_LIST = "RENT_VEHICLE_LIST";
export const RENT_VEHICLE_DELETE = "RENT_VEHICLE_DELETE";
export const BOOKED_RENT_VEHICLE_LIST = "BOOKED_RENT_VEHICLE_LIST";
export const RENTALS_ORDERS_DETAILS = "RENTALS_ORDERS_DETAILS";
export const LOADING = "LOADING";
export const ADD_NOTES = "ADD_NOTES";
export const ADD0N_VEHICLES_LIST = "ADD0N_VEHICLES_LIST"
export const GET_ORDER_BY_ID = 'GET_ORDER_BY_ID'
export const ADDON_VEHICLE_DELETE= "ADDON_VEHICLE_DELETE"
export const NOT_FOUND = 'NOT_FOUND'
// 
export const GET_ORDERS = 'GET_ORDERS'

export const TRANSATION_LIST = "TRANSATION_LIST";
export const TRANSATION_ADD = "TRANSATION_ADD";
export const TRANSATION_DELETE = "TRANSATION_DELETE";
export const UPDATE_TRANSATION = "TRANSATION_UPDATE";
export const TRANSATION_DETAIL = "TRANSATION_DETAIL";
export const SURGE_PRICE_LIST = "SURGE_PRICE_LIST";
export const ADD_SURGE_PRICE = "SURGE_PRICE_ADD";
export const SURGE_PRICE_DELETE = "SURGE_PRICE_DELETE";
export const UPDATE_SURGE_PRICE = "SURGE_PRICE_UPDATE";
export const SURGE_PRICE_DETAIL = "SURGE_PRICE_DETAIL";

export const AFFILIATE_LIST = "AFFILIATE_LIST";
export const AFFILIATE_UPDATE = "AFFILIATE_UPDATE";
export const AFFILIATE_DELETE = "AFFILIATE_DELETE";
